import { z } from "zod";
import { isObject } from "@common/helpers/typeGuards";
import { EntityProfile } from "@common/types/entity";

// Passed through unchanged: legacy jsonb holds values outside the current
// profile enums, and profile edits send the whole object back, so dropping
// anything here would erase it on the next save.
export const entityProfileResponseSchema = z
    .custom<EntityProfile>(isObject)
    .nullable()
    .catch(null);
